import * as React from 'react';
import HeaderFlexPane from './HeaderFlexPane';
import HeaderPaneProps from './HeaderPaneProps';
import strings from 'owa-strings/owa-common-strings';
import { FeedbackForm } from 'owa-feedback';
import { observer } from 'mobx-react';

const styles = require('./FeedbackPane.scss');

@observer
export default class FeedbackPane extends React.Component<HeaderPaneProps, {}> {
    private onSend = () => {
        this.props.onDismiss();
    };

    renderFeedbackForm(): JSX.Element {
        return (
            <div className={styles.menuFeedback}>
                <FeedbackForm onSendFeedback={this.onSend} />
            </div>
        );
    }

    render() {
        return (
            <HeaderFlexPane
                title={() => strings.feedbackCharm_ariaLabel}
                content={this.renderFeedbackForm()}
                onDismiss={this.props.onDismiss}
            />
        );
    }
}
